// (function () {
//     'use strict';
//
//     angular
//         .module('sodDocumentLibrary')
//         .directive('sodDocumentLibraryPreview', sodDocumentLibraryPreview);
//
//     function sodDocumentLibraryPreview() {
//         return {
//             restrict: 'E',
//             controller: sodDocumentLibraryPreviewCtrl,
//             controllerAs: 'vm',
//             bindToController: true,
//             scope: {
//                 document: '='
//             },
//             templateUrl: ''
//         };
//     }
//
//     function sodDocumentLibraryPreviewCtrl() {
//         var vm = this;
//
//     }
// })();